module.exports = __webpack_public_path__ + "static/img/btn-satisfaction-3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-satisfaction-3.png
// module id = 522
// module chunks = 0